import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PublicApiCall } from "../../apis/PublicApiCall";
import { ReactComponent as YUJA_LOGO } from "../../images/yujalogo.svg";
import {
    ACCOUNT_CARD_LOGOUT_TEXT,
    ACCOUNT_CARD_SUPPORT_TEXT,
     NAVBAR_ENGAGE
} from "../../utils/constants";
import { useLoading } from "../../utils/LoadingContext";
import useQuery from "../../utils/queryparam";
import styles from "./PPTLayout.module.css";
import { NavDropdown } from "react-bootstrap";
import YuJaHelpModal from "../../components/modals/YujaHelpModal";
import { usePPTWebView } from "../../hooks/usePPTWebView";
import { ReactComponent as LogOut } from "../../images/LogoutIcon.svg";
import { ReactComponent as Support } from "../../images/SupportIcon.svg";
import { roleValuetoDisplay } from "../../utils/helpers";
import ProfileIcon from "../../components/ProfileIcon";
import {useConfig} from "../../hooks/useConfig";

export default function PPTLayout({children,}) {
    const { setLoading } = useLoading();
    const { appId } = useParams();
    const query = useQuery();
    const {checkExpired, parseToken, goLoginPage} = usePPTWebView();
    const config = useConfig();
    const {postPPTMessage} = PublicApiCall();

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("")
    const [role, setRole] = useState("");
    const [token, ] = useState(() => query.get("token"));

    const [showModal, setShowModal] = useState(false);
    const [pinCode, setPinCode] = useState("");

    useEffect(() => {
        if (checkExpired()) {
            //1. post websocket message
            postPPTMessage(appId, JSON.stringify({action: "clean"})).then(() => {
                //2. do redirect
                goLoginPage();
            });
            return;
        }

        const {firstName="", lastName="", role: roleVal="", email="", pinCode=""} = parseToken();

        let name = "";
        if (!!firstName) {
            name = firstName;
        }

        if (!!lastName) {
            name = !!name ? `${firstName} ${lastName}` : lastName;
        }
        setUserName(name);
        setEmail(email); 
        setRole(roleVal);
        setPinCode(!!pinCode ? pinCode : "");
    }, []);

    const logout = () => {
        //1. post websocket message
        setLoading(true);
        postPPTMessage(appId, JSON.stringify({action: "clean"})).then(() => {
            //2. do redirect
            window.open(`${config.ppt_mgmt_portal}/PPT/${appId}/dispatch`, "_self");
        }).finally(() => {
            setLoading(false);
        });
    }


    return (
        <div className={styles.container}>
              <YuJaHelpModal showModal={showModal} setShowModal={setShowModal} userName={userName} userEmail={email} />
            <div className={styles.topBarContainer}>
                <div className={styles.logoContainer}>
                    <YUJA_LOGO width={24} height={24}/>
                </div>
                <span className={styles.title} >{NAVBAR_ENGAGE}</span>
                <div style={{flex: 1}}/>

                <NavDropdown
                    className = {"navDropdown"}
                    title={(
                        <div style={{display: "flex", alignItems: "center"}}>
                            <ProfileIcon
                                size={33}
                                initialLetter={userName[0] ? userName[0] : "G"}
                            />
                    </div>
                    )}
                    style={{padding: 0}}>
                    {/* <Dropdown.Toggle
                        as={React.forwardRef(({ children, onClick }, ref) => (
                            <span
                                ref={ref}
                                style={{cursor: "pointer", display: "flex", alignItems: "center"}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    onClick(e);
                                }}
                            >
                                <BiUserCircle size={25} style={{marginRight: 5, color: "#FFFFFF"}}/>
                                <span className={styles.description} style={{color: "#FFFFFF", fontSize: 16}} >{userName}</span>
                                <MdKeyboardArrowDown size={20} style={{color: "#FFFFFF"}}/>
                            </span>
                        ))}
                    /> */}
                    {/* <Dropdown.Menu style={{width: 150}}>
                        <Dropdown.Item eventKey="3" onClick={logout}>Log out</Dropdown.Item>
                    </Dropdown.Menu> */}
                    <ul role="menu"
                        tabIndex={0}
                        style={{
                            boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 5px 0px", padding: "8px 0px", marginTop: "7px",
                            position: "absolute", right: 5,  backgroundColor: "#FFFFFF", borderRadius: "5px",
                            display: "flex",  alignItems: "center", flexDirection: "column", cursor: "initial",
                            width: 180, height: "fit-content"
                        }}
                    >
                        <ProfileIcon
                            size={45}
                            initialLetter={userName[0] ? userName[0] : "G"}
                            style={{ margin: 10}}
                        />


                      <div
                          style={{
                              textAlign: "center", fontWeight: 700, fontSize: 20,
                              overflow: "hidden", maxWidth: "175px", whiteSpace: "nowrap",
                              textOverflow: "ellipsis", paddingLeft: "10px", paddingRight: "10px"
                          }}
                      >{userName ? userName: "Guest"} </div>
                        <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.5}}>
                            {roleValuetoDisplay(role)}
                        </div>
                        <div
                            title={email}
                            style={{
                                overflow: "hidden", maxWidth: "175px",
                                textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "14px", lineHeight: 1.5,
                                paddingLeft: "10px", paddingRight: "10px"
                            }}
                        > {email} </div>
                        {!!pinCode &&
                            <div style={{color: "#6F6F6F", fontSize: 14, lineHeight: 1.5}}>
                                {`PIN: ${pinCode}`}
                            </div>
                        }
                      <hr style={{width: "100%", margin: "10px 0"}}/>
                        <NavDropdown.Item tabIndex={0} onClick={() => {setShowModal(true)}} style={{ fontSize: "15px", display: "flex"}}>
                            <span style={{display: "flex", alignItems: "center", gap: 10, width: 150}}><Support size={24} style={{width: 24 , height: 24}}/>{ACCOUNT_CARD_SUPPORT_TEXT} </span>
                        </NavDropdown.Item>
                        <hr style={{width: "100%", margin: "10px 0"}}/>
                        <NavDropdown.Item tabIndex={0} onClick={logout} style={{ fontSize: "15px", display: "flex"}}>
                            <span style={{display: "flex", alignItems: "center", gap: 10, width: 150}}><LogOut size={24} style={{width: 24 , height: 24}}/>{ACCOUNT_CARD_LOGOUT_TEXT} </span>
                        </NavDropdown.Item>
                      </ul>
                </NavDropdown>
            </div>

            <div style={{flex: 1, width: "100%", display: "flex", position: "relative", overflow: "auto"}}>
                {/*<div className={styles.sideBarContainer} style={{width: (collapsed ? COLLAPSED_SIDE_BAR_WIDTH : EXPANDED_SIDE_BAR_WIDTH)}}>*/}
                {/*    <div className={styles.sidebarMenu} onMouseLeave={() => setCollapsed(true)} onMouseEnter={() => setCollapsed(false)}>*/}
                {/*        <div style={{padding: "20px 5px 0 5px"}}>*/}
                {/*                {Object.values(PPT_MENU_LIST).filter(menu => menu.roles.includes(role)).map((menu, idx) => (*/}
                {/*                    <div key={idx}>*/}
                {/*                        {menu.name === PPT_MENU_LIST.CREATE.name &&*/}
                {/*                            <>*/}
                {/*                                <div*/}
                {/*                                    tabIndex={0}*/}
                {/*                                    aria-label={menu.name}*/}
                {/*                                    role={BUTTON}*/}
                {/*                                    id={`menu-link-${idx}`}*/}
                {/*                                    onClick={() => {*/}
                {/*                                        setShowCreateOptions(collapsed ? true : !showCreateOptions);*/}
                {/*                                        updateShowCreateOptions(collapsed ? true : !showCreateOptions);*/}
                {/*                                        setCollapsed(false);*/}
                {/*                                    }}*/}
                {/*                                    className={`${(isActiveCreatePollPage() && collapsed) ? styles.activeSideBarLink : styles.sidebarLink}`}*/}
                {/*                                    hidden={!menu.roles.includes(role)}*/}
                {/*                                    style={{display: "flex", justifyContent: "space-between"}}*/}
                {/*                                >*/}
                {/*                                    <div style={{width: "100%"}}>*/}
                {/*                                        {!collapsed && <div>*/}
                {/*                                            <img*/}
                {/*                                                id={`menu-icon-${menu.name}`}*/}
                {/*                                                src={menu.icon}*/}
                {/*                                                style={{width: "50px", height: "18px", marginRight: "5px"}}*/}
                {/*                                                alt={`${menu.name} icon`}*/}
                {/*                                            />*/}
                {/*                                            <span className={styles.sidebarText}>{menu.name}</span>*/}
                {/*                                        </div>}*/}
                {/*                                        {collapsed &&*/}
                {/*                                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>*/}
                {/*                                                <img*/}
                {/*                                                    id={`menu-icon-${menu.name}`}*/}
                {/*                                                    src={isActiveCreatePollPage() ? menu.activeIcon : menu.icon}*/}
                {/*                                                    style={{height: "18px"}}*/}
                {/*                                                    alt={`${menu.name} icon`}*/}
                {/*                                                    className={`${isActiveCreatePollPage() ? styles.activeSubIcon: ""}`}*/}
                {/*                                                />*/}
                {/*                                            </div>*/}
                {/*                                        }*/}
                {/*                                    </div>*/}
                {/*                                    {!collapsed && showCreateOptions && window.location.pathname === menu.path &&*/}
                {/*                                        <ActiveUp style={{width: "18px", cursor: "pointer", marginRight: "5px"}}/>*/}
                {/*                                    }*/}
                {/*                                    {!collapsed &&  showCreateOptions && window.location.pathname !== menu.path &&*/}
                {/*                                        <Up style={{width: "18px", cursor: "pointer", marginRight: "5px"}}/>*/}
                {/*                                    }*/}

                {/*                                    {!collapsed &&  !showCreateOptions && window.location.pathname === menu.path &&*/}
                {/*                                        <ActiveDown style={{width: "18px", cursor: "pointer", marginRight: "5px"}}/>*/}
                {/*                                    }*/}
                {/*                                    {!collapsed && !showCreateOptions && window.location.pathname !== menu.path &&*/}
                {/*                                        <Down style={{width: "18px", cursor: "pointer", marginRight: "5px"}}/>*/}
                {/*                                    }*/}
                {/*                                </div>*/}
                {/*                                {!collapsed && showCreateOptions &&*/}
                {/*                                    <div className={styles.createOptionWrap}>*/}
                {/*                                        <span*/}
                {/*                                            tabIndex={0}*/}
                {/*                                            onClick={goCreatePollPage}*/}
                {/*                                            className={`${isActiveCreateMergedPollPage() ? styles.activeSideBarLink : styles.createOption}`}*/}
                {/*                                        >*/}
                {/*                                            <div>*/}
                {/*                                                <img*/}
                {/*                                                    id={`menu-icon-${menu.name}`}*/}
                {/*                                                    src={isActiveCreateMergedPollPage() ? ActiveCreatePollIcon : CreatePollIcon}*/}
                {/*                                                    style={{*/}
                {/*                                                        width: "50px",*/}
                {/*                                                        height: "18px",*/}
                {/*                                                        marginRight: "5px",*/}
                {/*                                                        marginLeft: "15px"*/}
                {/*                                                    }}*/}
                {/*                                                    alt={`${menu.name} poll icon`}*/}
                {/*                                                    className={`${isActiveCreateMergedPollPage() ? styles.activeSubIcon : ""}`}*/}
                {/*                                                />*/}
                {/*                                                <span className={styles.sidebarText}>{POLL_TEXT}</span>*/}
                {/*                                            </div>*/}
                {/*                                        </span>*/}
                {/*                                        <span*/}
                {/*                                            tabIndex={0}*/}
                {/*                                            onClick={goCreateAttendancePage}*/}
                {/*                                            className={`${isActiveCreateAttendancePage() ? styles.activeSideBarLink : styles.createOption}`}*/}
                {/*                                        >*/}
                {/*                                           <div>*/}
                {/*                                                <img*/}
                {/*                                                    id={`menu-icon-${menu.name}`}*/}
                {/*                                                    src={isActiveCreateAttendancePage() ? ActiveCreateAttendanceIcon : CreateAttendanceIcon}*/}
                {/*                                                    style={{*/}
                {/*                                                        width: "50px",*/}
                {/*                                                        height: "18px",*/}
                {/*                                                        marginRight: "5px",*/}
                {/*                                                        marginLeft: "15px"*/}
                {/*                                                    }}*/}
                {/*                                                    alt={`${menu.name} survey icon`}*/}
                {/*                                                    className={`${isActiveCreateSurveyPage() ? styles.activeSubIcon : ""}`}*/}
                {/*                                                />*/}
                {/*                                                <span*/}
                {/*                                                    className={styles.sidebarText}>{ATTENDANCE_TEXT}</span>*/}
                {/*                                           </div>*/}
                {/*                                        </span>*/}
                {/*                                    </div>*/}
                {/*                                }*/}
                {/*                            </>*/}
                {/*                        }*/}
                {/*                        {menu.name !== PPT_MENU_LIST.CREATE.name &&*/}
                {/*                            <span*/}
                {/*                                tabIndex={0}*/}
                {/*                                aria-label={menu.name}*/}
                {/*                                role={BUTTON}*/}
                {/*                                id={`menu-link-${idx}`}*/}
                {/*                                onClick={() => {*/}
                {/*                                    setShowCreateOptions(false);*/}
                {/*                                    goAnyPage(menu.path);*/}
                {/*                                }}*/}
                {/*                                className={`${window.location.pathname.includes(menu.path) ? styles.activeSideBarLink : styles.sidebarLink}`}*/}
                {/*                                hidden={!menu.roles.includes(role)}*/}
                {/*                            >*/}
                {/*                                {!collapsed &&*/}
                {/*                                    <div>*/}
                {/*                                        <img*/}
                {/*                                            id={`menu-icon-${menu.name}`}*/}
                {/*                                            src={window.location.pathname.includes(menu.path) ? menu.activeIcon : menu.icon}*/}
                {/*                                            style={{width: "50px", height: "18px", marginRight: "5px"}}*/}
                {/*                                            alt={`${menu.name} icon`}*/}
                {/*                                            className={`${window.location.pathname.includes(menu.path) ? styles.activeSubIcon: ""}`}*/}
                {/*                                        />*/}
                {/*                                        <span className={styles.sidebarText}>{menu.name}</span>*/}
                {/*                                    </div>*/}
                {/*                                }*/}
                {/*                                {collapsed &&*/}
                {/*                                    <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>*/}
                {/*                                        <img*/}
                {/*                                            id={`menu-icon-${menu.name}`}*/}
                {/*                                            src={window.location.pathname.includes(menu.path) ? menu.activeIcon : menu.icon}*/}
                {/*                                            style={{height: "18px"}}*/}
                {/*                                            alt={`${menu.name} icon`}*/}
                {/*                                            className={`${window.location.pathname.includes(menu.path) ? styles.activeSubIcon: ""}`}*/}
                {/*                                        />*/}
                {/*                                    </div>*/}
                {/*                                }*/}
                {/*                            </span>*/}
                {/*                        }*/}
                {/*                    </div>*/}
                {/*                ))}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {!!token &&
                    <main className={styles.majorContainer}>{children}</main>
                }
                <div id="sr-feedback" aria-live="polite" aria-atomic="true"></div>
            </div>
        </div>
    );
}